/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const face_shields : {[key: string]: Array<[string, string]>} = {
};
